import React from "react";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  DialogTitle,
  Dialog,
  Skeleton,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import { calendarioApi } from "src/services/calendarioApi";

export default function DialogVerEmpleadosActividad({ open, setOpen, id }) {
  const { data: empleados = null, isLoading } =
    calendarioApi.useGetEmpleadosActividadQuery(id, {
      skip: !id,
    });
  const cargandoDatos = !isLoading;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="sm">
      <DialogTitle>Personas Asociadas</DialogTitle>
      {cargandoDatos ? (
        <List sx={{ pt: 0 }}>
          {empleados === null ? (
            <ListItem>
              <ListItemText primary="Error al obtener los datos" />
            </ListItem>
          ) : (
            empleados.map((item, idx) => (
              <ListItem
                key={`empleadosAsociados_${idx}`}
                secondaryAction={
                  item.aceptado ? (
                    <Typography color="primary">{"Aceptado"}</Typography>
                  ) : (
                    <Typography color="error">{"No Aceptado"}</Typography>
                  )
                }
              >
                <ListItemAvatar>
                  <Avatar>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={`${item.empleado.nombre} ${item.empleado.apellidos}`}
                />
              </ListItem>
            ))
          )}
        </List>
      ) : (
        <Skeleton variant="rectangular" width="100%" height="200px" />
      )}
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
